import React from "react";
import { ContactPageMetadata } from "./ContactPage.metadata";
import { styles } from "./ContactPage.styles";
import { ContactPageContainer } from "./ContactPage.container";
import { bem, ContactForm, PrimaryButton } from "@obby/components";
import { FeaturedBlogPosts } from "./FeaturedBlogPosts";
import { FeaturedCategories } from "./FeaturedCategories";

const cn = bem("contact-page");
export function ContactPageView(props) {
  const {
    isSending,
    isSent,
    values,
    touched,
    errors,
    actions
  } = ContactPageContainer.useContainer();

  return (
    <div className={`${cn()} ${styles.contactPage}`}>
      <ContactPageMetadata />
      <div className="container-fluid">
        {isSent && (
          <div className="thank-you-container">
            <div className="my-5">
              <h1 className={`${cn("heading")} ${styles.heading}`}>
                Thank you!
              </h1>
              <h2 className={`${cn("subheading")} ${styles.subheading}`}>
                We'll get in touch soon :)
              </h2>
            </div>

            <div className={`${cn("section")} ${styles.section}`}>
              <div className={`${cn("section-title")} ${styles.sectionTitle}`}>
                Find your next class
              </div>
              <div
                className={`${cn("section-description")} ${
                  styles.sectionDescription
                }`}
              >
                Browse our local classes, courses and workshops and start
                learning with London's best teachers
              </div>
              <div className="mt-4">
                <FeaturedCategories />
              </div>
            </div>

            <div className={`${cn("section")} ${styles.section}`}>
              <div className={`${cn("section-title")} ${styles.sectionTitle}`}>
                Discover our community
              </div>
              <div
                className={`${cn("section-description")} ${
                  styles.sectionDescription
                }`}
              >
                Stories from the Obby journey
              </div>
              <div className="mt-4">
                <FeaturedBlogPosts />
              </div>
            </div>
          </div>
        )}

        {!isSent && (
          <>
            <div className="row">
              <div className="col-12 col-sm-8 offset-sm-2">
                <h1
                  className={`${cn("heading", null, ["my-4"])} ${
                    styles.heading
                  }`}
                >
                  Contact Obby - Get in touch
                </h1>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-8 offset-sm-2">
                <ContactForm
                  values={values}
                  errors={errors}
                  touched={touched}
                  onChange={actions.onChange}
                  onBlur={actions.onBlur}
                />

                <div className="my-4">
                  <PrimaryButton
                    disabled={isSending}
                    text={isSending ? "Sending..." : "Send message"}
                    width="auto"
                    onClick={actions.onSubmit}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
